export const HOME = "/";
//#region NEW ROUTES
export const LOGIN = "/login";
export const SIGNUP = "/signup";
export const ABOUT = "/about";
export const CONTACT = "/contact";
//#endregion
export const NOT_FOUND = "/not-found";
